import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

import * as RewardCardService from '../../api/rewardCardService';
import useCompanyContext from '../../hooks/useCompanyContext';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(),
    width: '100%',
  },
  title: {
    marginTop: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'left',
  },
  subtext: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    fontSize: 16,
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  rewardCardId: string;
  memberId: string;
  confirmDelete: () => void;
};

export default function DeleteRewardDialog({
  rewardCardId,
  memberId,
  onClose,
  open,
  confirmDelete,
}: Props) {
  const classes = useStyles();
  const { company } = useCompanyContext();

  const handleDeleteRewardCard = async () => {
    if (company && rewardCardId) {
      try {
        await RewardCardService.deleteRewardCard(
          company.id,
          memberId,
          rewardCardId
        );
        confirmDelete();
      } catch (e: any) {
        console.log('Error: ', e);
        if (onClose) {
          onClose(e, 'backdropClick');
        }
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <div className={classes.cardContainer}>
        <Typography className={classes.title} gutterBottom>
          Delete Reward
        </Typography>
        <Typography variant="body2" className={classes.subtext} gutterBottom>
          Permanently delete reward? This action cannot be undone.
        </Typography>
      </div>
      <div className={classes.actionContainer}>
        <Button
          className={classes.buttonContainer}
          onClick={(e) => (onClose ? onClose(e, 'backdropClick') : null)}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          className={classes.buttonContainer}
          onClick={() => handleDeleteRewardCard()}
        >
          Delete
        </Button>
      </div>
    </Dialog>
  );
}
